import { render } from "./IconThanksMessage.vue?vue&type=template&id=0ca47a57"
import script from "./IconThanksMessage.vue?vue&type=script&lang=js"
export * from "./IconThanksMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__